export type Fetch = typeof fetch
export type FetchConfig = (nextFetch: Fetch) => Fetch

export type FetchDialogMode = 'info' | 'retry' | 'silent'

declare global {
  export interface RequestInit {
    sablier?: boolean
    dialogMode?: FetchDialogMode
    dialogExcludeErrors?: number[]
    /** A utiliser pour le Upload de fichiers */
    noDefaultContentType?: boolean
    appCache?: true
    appCacheDurationEnSecondes?: number,
    appCacheAddKey?: string | number | Array<string | number | undefined | null>,
    /** Demande le rechargement de la page sur une erreur de concurrence */
    reloadPageOnConcurrencyException?: true
    /** Desactive le blocage imperso */
    blocageImpersoDisabled?: true
  }
}

export class ConcurrencyException extends Error { }
